// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__ZbpCr","contact_button":"Contact_contact_button__ePtQz"};